module.exports = __webpack_public_path__ + "static/media/childrens-hospital.a94c7612.jpg";